export type GalleryType = "generic" | "challenge" | "content" | "event"
export const galleryTypes: GalleryType[] = ["generic", "challenge"];
